import styles from './LoadingSpinner.module.less'
import cls from 'classnames'

interface LoadingSpinnerProps {
  size?: number
  color?: string
  className?: string
  style?: React.CSSProperties
}

export function LoadingSpinner(props: LoadingSpinnerProps) {
  const { size = 16, color = '#ACAEBA', className } = props
  return (
    <span
      className={cls(styles.spinner, className)}
      style={{
        ...props.style,
        minWidth: size,
        width: size,
        height: size,
        borderColor: `${color} #f6f6f6 #f6f6f6 #f6f6f6`,
      }}
    />
  )
}
